import { render } from "./trainTimeLine.vue?vue&type=template&id=60fad10c&scoped=true"
const script = {}

import "./trainTimeLine.vue?vue&type=style&index=0&id=60fad10c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fad10c"]])

export default __exports__